import { FeatureFlag } from '../FeatureFlag';

export const useWidgetTabIdForUserViewKey = new FeatureFlag({
    key: 'use-widget-tab-id-for-user-view-key',
    defaultValue: false,
});
